module.exports = new __parcel__URL__("3.dc807893.svg").toString();